require('../../../../../vendor/assets/javascripts/i18n/moment/default')
